export enum IEmploymentType {
  FullTime = 'fulltime',
  PartTime = 'parttime',
  Contractor = 'contractor',
}

export const employmentTypeToLabel = {
  [IEmploymentType.FullTime]: 'Full Time',
  [IEmploymentType.PartTime]: 'Part Time',
  [IEmploymentType.Contractor]: 'Contractor',
};
